shadow$provide[512] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, ACESFilmicToneMapping:{enumerable:true, get:function() {
  return ACESFilmicToneMapping;
}}, AddEquation:{enumerable:true, get:function() {
  return AddEquation;
}}, AddOperation:{enumerable:true, get:function() {
  return AddOperation;
}}, AdditiveAnimationBlendMode:{enumerable:true, get:function() {
  return AdditiveAnimationBlendMode;
}}, AdditiveBlending:{enumerable:true, get:function() {
  return AdditiveBlending;
}}, AgXToneMapping:{enumerable:true, get:function() {
  return AgXToneMapping;
}}, AlphaFormat:{enumerable:true, get:function() {
  return AlphaFormat;
}}, AlwaysCompare:{enumerable:true, get:function() {
  return AlwaysCompare;
}}, AlwaysDepth:{enumerable:true, get:function() {
  return AlwaysDepth;
}}, AlwaysStencilFunc:{enumerable:true, get:function() {
  return AlwaysStencilFunc;
}}, AttachedBindMode:{enumerable:true, get:function() {
  return AttachedBindMode;
}}, BackSide:{enumerable:true, get:function() {
  return BackSide;
}}, BasicDepthPacking:{enumerable:true, get:function() {
  return BasicDepthPacking;
}}, BasicShadowMap:{enumerable:true, get:function() {
  return BasicShadowMap;
}}, ByteType:{enumerable:true, get:function() {
  return ByteType;
}}, CineonToneMapping:{enumerable:true, get:function() {
  return CineonToneMapping;
}}, ClampToEdgeWrapping:{enumerable:true, get:function() {
  return ClampToEdgeWrapping;
}}, Compatibility:{enumerable:true, get:function() {
  return Compatibility;
}}, ConstantAlphaFactor:{enumerable:true, get:function() {
  return ConstantAlphaFactor;
}}, ConstantColorFactor:{enumerable:true, get:function() {
  return ConstantColorFactor;
}}, CubeReflectionMapping:{enumerable:true, get:function() {
  return CubeReflectionMapping;
}}, CubeRefractionMapping:{enumerable:true, get:function() {
  return CubeRefractionMapping;
}}, CubeUVReflectionMapping:{enumerable:true, get:function() {
  return CubeUVReflectionMapping;
}}, CullFaceBack:{enumerable:true, get:function() {
  return CullFaceBack;
}}, CullFaceFront:{enumerable:true, get:function() {
  return CullFaceFront;
}}, CullFaceFrontBack:{enumerable:true, get:function() {
  return CullFaceFrontBack;
}}, CullFaceNone:{enumerable:true, get:function() {
  return CullFaceNone;
}}, CustomBlending:{enumerable:true, get:function() {
  return CustomBlending;
}}, CustomToneMapping:{enumerable:true, get:function() {
  return CustomToneMapping;
}}, DecrementStencilOp:{enumerable:true, get:function() {
  return DecrementStencilOp;
}}, DecrementWrapStencilOp:{enumerable:true, get:function() {
  return DecrementWrapStencilOp;
}}, DepthFormat:{enumerable:true, get:function() {
  return DepthFormat;
}}, DepthStencilFormat:{enumerable:true, get:function() {
  return DepthStencilFormat;
}}, DetachedBindMode:{enumerable:true, get:function() {
  return DetachedBindMode;
}}, DoubleSide:{enumerable:true, get:function() {
  return DoubleSide;
}}, DstAlphaFactor:{enumerable:true, get:function() {
  return DstAlphaFactor;
}}, DstColorFactor:{enumerable:true, get:function() {
  return DstColorFactor;
}}, DynamicCopyUsage:{enumerable:true, get:function() {
  return DynamicCopyUsage;
}}, DynamicDrawUsage:{enumerable:true, get:function() {
  return DynamicDrawUsage;
}}, DynamicReadUsage:{enumerable:true, get:function() {
  return DynamicReadUsage;
}}, EqualCompare:{enumerable:true, get:function() {
  return EqualCompare;
}}, EqualDepth:{enumerable:true, get:function() {
  return EqualDepth;
}}, EqualStencilFunc:{enumerable:true, get:function() {
  return EqualStencilFunc;
}}, EquirectangularReflectionMapping:{enumerable:true, get:function() {
  return EquirectangularReflectionMapping;
}}, EquirectangularRefractionMapping:{enumerable:true, get:function() {
  return EquirectangularRefractionMapping;
}}, FloatType:{enumerable:true, get:function() {
  return FloatType;
}}, FrontSide:{enumerable:true, get:function() {
  return FrontSide;
}}, GLSL1:{enumerable:true, get:function() {
  return GLSL1;
}}, GLSL3:{enumerable:true, get:function() {
  return GLSL3;
}}, GreaterCompare:{enumerable:true, get:function() {
  return GreaterCompare;
}}, GreaterDepth:{enumerable:true, get:function() {
  return GreaterDepth;
}}, GreaterEqualCompare:{enumerable:true, get:function() {
  return GreaterEqualCompare;
}}, GreaterEqualDepth:{enumerable:true, get:function() {
  return GreaterEqualDepth;
}}, GreaterEqualStencilFunc:{enumerable:true, get:function() {
  return GreaterEqualStencilFunc;
}}, GreaterStencilFunc:{enumerable:true, get:function() {
  return GreaterStencilFunc;
}}, HalfFloatType:{enumerable:true, get:function() {
  return HalfFloatType;
}}, IncrementStencilOp:{enumerable:true, get:function() {
  return IncrementStencilOp;
}}, IncrementWrapStencilOp:{enumerable:true, get:function() {
  return IncrementWrapStencilOp;
}}, IntType:{enumerable:true, get:function() {
  return IntType;
}}, InterpolateBezier:{enumerable:true, get:function() {
  return InterpolateBezier;
}}, InterpolateDiscrete:{enumerable:true, get:function() {
  return InterpolateDiscrete;
}}, InterpolateLinear:{enumerable:true, get:function() {
  return InterpolateLinear;
}}, InterpolateSmooth:{enumerable:true, get:function() {
  return InterpolateSmooth;
}}, InterpolationSamplingMode:{enumerable:true, get:function() {
  return InterpolationSamplingMode;
}}, InterpolationSamplingType:{enumerable:true, get:function() {
  return InterpolationSamplingType;
}}, InvertStencilOp:{enumerable:true, get:function() {
  return InvertStencilOp;
}}, KeepStencilOp:{enumerable:true, get:function() {
  return KeepStencilOp;
}}, LessCompare:{enumerable:true, get:function() {
  return LessCompare;
}}, LessDepth:{enumerable:true, get:function() {
  return LessDepth;
}}, LessEqualCompare:{enumerable:true, get:function() {
  return LessEqualCompare;
}}, LessEqualDepth:{enumerable:true, get:function() {
  return LessEqualDepth;
}}, LessEqualStencilFunc:{enumerable:true, get:function() {
  return LessEqualStencilFunc;
}}, LessStencilFunc:{enumerable:true, get:function() {
  return LessStencilFunc;
}}, LinearFilter:{enumerable:true, get:function() {
  return LinearFilter;
}}, LinearMipMapLinearFilter:{enumerable:true, get:function() {
  return LinearMipMapLinearFilter;
}}, LinearMipMapNearestFilter:{enumerable:true, get:function() {
  return LinearMipMapNearestFilter;
}}, LinearMipmapLinearFilter:{enumerable:true, get:function() {
  return LinearMipmapLinearFilter;
}}, LinearMipmapNearestFilter:{enumerable:true, get:function() {
  return LinearMipmapNearestFilter;
}}, LinearSRGBColorSpace:{enumerable:true, get:function() {
  return LinearSRGBColorSpace;
}}, LinearToneMapping:{enumerable:true, get:function() {
  return LinearToneMapping;
}}, LinearTransfer:{enumerable:true, get:function() {
  return LinearTransfer;
}}, LoopOnce:{enumerable:true, get:function() {
  return LoopOnce;
}}, LoopPingPong:{enumerable:true, get:function() {
  return LoopPingPong;
}}, LoopRepeat:{enumerable:true, get:function() {
  return LoopRepeat;
}}, MOUSE:{enumerable:true, get:function() {
  return MOUSE;
}}, MaterialBlending:{enumerable:true, get:function() {
  return MaterialBlending;
}}, MaxEquation:{enumerable:true, get:function() {
  return MaxEquation;
}}, MinEquation:{enumerable:true, get:function() {
  return MinEquation;
}}, MirroredRepeatWrapping:{enumerable:true, get:function() {
  return MirroredRepeatWrapping;
}}, MixOperation:{enumerable:true, get:function() {
  return MixOperation;
}}, MultiplyBlending:{enumerable:true, get:function() {
  return MultiplyBlending;
}}, MultiplyOperation:{enumerable:true, get:function() {
  return MultiplyOperation;
}}, NearestFilter:{enumerable:true, get:function() {
  return NearestFilter;
}}, NearestMipMapLinearFilter:{enumerable:true, get:function() {
  return NearestMipMapLinearFilter;
}}, NearestMipMapNearestFilter:{enumerable:true, get:function() {
  return NearestMipMapNearestFilter;
}}, NearestMipmapLinearFilter:{enumerable:true, get:function() {
  return NearestMipmapLinearFilter;
}}, NearestMipmapNearestFilter:{enumerable:true, get:function() {
  return NearestMipmapNearestFilter;
}}, NeutralToneMapping:{enumerable:true, get:function() {
  return NeutralToneMapping;
}}, NeverCompare:{enumerable:true, get:function() {
  return NeverCompare;
}}, NeverDepth:{enumerable:true, get:function() {
  return NeverDepth;
}}, NeverStencilFunc:{enumerable:true, get:function() {
  return NeverStencilFunc;
}}, NoBlending:{enumerable:true, get:function() {
  return NoBlending;
}}, NoColorSpace:{enumerable:true, get:function() {
  return NoColorSpace;
}}, NoNormalPacking:{enumerable:true, get:function() {
  return NoNormalPacking;
}}, NoToneMapping:{enumerable:true, get:function() {
  return NoToneMapping;
}}, NormalAnimationBlendMode:{enumerable:true, get:function() {
  return NormalAnimationBlendMode;
}}, NormalBlending:{enumerable:true, get:function() {
  return NormalBlending;
}}, NormalGAPacking:{enumerable:true, get:function() {
  return NormalGAPacking;
}}, NormalRGPacking:{enumerable:true, get:function() {
  return NormalRGPacking;
}}, NotEqualCompare:{enumerable:true, get:function() {
  return NotEqualCompare;
}}, NotEqualDepth:{enumerable:true, get:function() {
  return NotEqualDepth;
}}, NotEqualStencilFunc:{enumerable:true, get:function() {
  return NotEqualStencilFunc;
}}, ObjectSpaceNormalMap:{enumerable:true, get:function() {
  return ObjectSpaceNormalMap;
}}, OneFactor:{enumerable:true, get:function() {
  return OneFactor;
}}, OneMinusConstantAlphaFactor:{enumerable:true, get:function() {
  return OneMinusConstantAlphaFactor;
}}, OneMinusConstantColorFactor:{enumerable:true, get:function() {
  return OneMinusConstantColorFactor;
}}, OneMinusDstAlphaFactor:{enumerable:true, get:function() {
  return OneMinusDstAlphaFactor;
}}, OneMinusDstColorFactor:{enumerable:true, get:function() {
  return OneMinusDstColorFactor;
}}, OneMinusSrcAlphaFactor:{enumerable:true, get:function() {
  return OneMinusSrcAlphaFactor;
}}, OneMinusSrcColorFactor:{enumerable:true, get:function() {
  return OneMinusSrcColorFactor;
}}, PCFShadowMap:{enumerable:true, get:function() {
  return PCFShadowMap;
}}, PCFSoftShadowMap:{enumerable:true, get:function() {
  return PCFSoftShadowMap;
}}, R11_EAC_Format:{enumerable:true, get:function() {
  return R11_EAC_Format;
}}, RED_GREEN_RGTC2_Format:{enumerable:true, get:function() {
  return RED_GREEN_RGTC2_Format;
}}, RED_RGTC1_Format:{enumerable:true, get:function() {
  return RED_RGTC1_Format;
}}, REVISION:{enumerable:true, get:function() {
  return REVISION;
}}, RG11_EAC_Format:{enumerable:true, get:function() {
  return RG11_EAC_Format;
}}, RGBADepthPacking:{enumerable:true, get:function() {
  return RGBADepthPacking;
}}, RGBAFormat:{enumerable:true, get:function() {
  return RGBAFormat;
}}, RGBAIntegerFormat:{enumerable:true, get:function() {
  return RGBAIntegerFormat;
}}, RGBA_ASTC_10x10_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_10x10_Format;
}}, RGBA_ASTC_10x5_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_10x5_Format;
}}, RGBA_ASTC_10x6_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_10x6_Format;
}}, RGBA_ASTC_10x8_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_10x8_Format;
}}, RGBA_ASTC_12x10_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_12x10_Format;
}}, RGBA_ASTC_12x12_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_12x12_Format;
}}, RGBA_ASTC_4x4_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_4x4_Format;
}}, RGBA_ASTC_5x4_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_5x4_Format;
}}, RGBA_ASTC_5x5_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_5x5_Format;
}}, RGBA_ASTC_6x5_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_6x5_Format;
}}, RGBA_ASTC_6x6_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_6x6_Format;
}}, RGBA_ASTC_8x5_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_8x5_Format;
}}, RGBA_ASTC_8x6_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_8x6_Format;
}}, RGBA_ASTC_8x8_Format:{enumerable:true, get:function() {
  return RGBA_ASTC_8x8_Format;
}}, RGBA_BPTC_Format:{enumerable:true, get:function() {
  return RGBA_BPTC_Format;
}}, RGBA_ETC2_EAC_Format:{enumerable:true, get:function() {
  return RGBA_ETC2_EAC_Format;
}}, RGBA_PVRTC_2BPPV1_Format:{enumerable:true, get:function() {
  return RGBA_PVRTC_2BPPV1_Format;
}}, RGBA_PVRTC_4BPPV1_Format:{enumerable:true, get:function() {
  return RGBA_PVRTC_4BPPV1_Format;
}}, RGBA_S3TC_DXT1_Format:{enumerable:true, get:function() {
  return RGBA_S3TC_DXT1_Format;
}}, RGBA_S3TC_DXT3_Format:{enumerable:true, get:function() {
  return RGBA_S3TC_DXT3_Format;
}}, RGBA_S3TC_DXT5_Format:{enumerable:true, get:function() {
  return RGBA_S3TC_DXT5_Format;
}}, RGBDepthPacking:{enumerable:true, get:function() {
  return RGBDepthPacking;
}}, RGBFormat:{enumerable:true, get:function() {
  return RGBFormat;
}}, RGBIntegerFormat:{enumerable:true, get:function() {
  return RGBIntegerFormat;
}}, RGB_BPTC_SIGNED_Format:{enumerable:true, get:function() {
  return RGB_BPTC_SIGNED_Format;
}}, RGB_BPTC_UNSIGNED_Format:{enumerable:true, get:function() {
  return RGB_BPTC_UNSIGNED_Format;
}}, RGB_ETC1_Format:{enumerable:true, get:function() {
  return RGB_ETC1_Format;
}}, RGB_ETC2_Format:{enumerable:true, get:function() {
  return RGB_ETC2_Format;
}}, RGB_PVRTC_2BPPV1_Format:{enumerable:true, get:function() {
  return RGB_PVRTC_2BPPV1_Format;
}}, RGB_PVRTC_4BPPV1_Format:{enumerable:true, get:function() {
  return RGB_PVRTC_4BPPV1_Format;
}}, RGB_S3TC_DXT1_Format:{enumerable:true, get:function() {
  return RGB_S3TC_DXT1_Format;
}}, RGDepthPacking:{enumerable:true, get:function() {
  return RGDepthPacking;
}}, RGFormat:{enumerable:true, get:function() {
  return RGFormat;
}}, RGIntegerFormat:{enumerable:true, get:function() {
  return RGIntegerFormat;
}}, RedFormat:{enumerable:true, get:function() {
  return RedFormat;
}}, RedIntegerFormat:{enumerable:true, get:function() {
  return RedIntegerFormat;
}}, ReinhardToneMapping:{enumerable:true, get:function() {
  return ReinhardToneMapping;
}}, RepeatWrapping:{enumerable:true, get:function() {
  return RepeatWrapping;
}}, ReplaceStencilOp:{enumerable:true, get:function() {
  return ReplaceStencilOp;
}}, ReverseSubtractEquation:{enumerable:true, get:function() {
  return ReverseSubtractEquation;
}}, SIGNED_R11_EAC_Format:{enumerable:true, get:function() {
  return SIGNED_R11_EAC_Format;
}}, SIGNED_RED_GREEN_RGTC2_Format:{enumerable:true, get:function() {
  return SIGNED_RED_GREEN_RGTC2_Format;
}}, SIGNED_RED_RGTC1_Format:{enumerable:true, get:function() {
  return SIGNED_RED_RGTC1_Format;
}}, SIGNED_RG11_EAC_Format:{enumerable:true, get:function() {
  return SIGNED_RG11_EAC_Format;
}}, SRGBColorSpace:{enumerable:true, get:function() {
  return SRGBColorSpace;
}}, SRGBTransfer:{enumerable:true, get:function() {
  return SRGBTransfer;
}}, ShortType:{enumerable:true, get:function() {
  return ShortType;
}}, SrcAlphaFactor:{enumerable:true, get:function() {
  return SrcAlphaFactor;
}}, SrcAlphaSaturateFactor:{enumerable:true, get:function() {
  return SrcAlphaSaturateFactor;
}}, SrcColorFactor:{enumerable:true, get:function() {
  return SrcColorFactor;
}}, StaticCopyUsage:{enumerable:true, get:function() {
  return StaticCopyUsage;
}}, StaticDrawUsage:{enumerable:true, get:function() {
  return StaticDrawUsage;
}}, StaticReadUsage:{enumerable:true, get:function() {
  return StaticReadUsage;
}}, StreamCopyUsage:{enumerable:true, get:function() {
  return StreamCopyUsage;
}}, StreamDrawUsage:{enumerable:true, get:function() {
  return StreamDrawUsage;
}}, StreamReadUsage:{enumerable:true, get:function() {
  return StreamReadUsage;
}}, SubtractEquation:{enumerable:true, get:function() {
  return SubtractEquation;
}}, SubtractiveBlending:{enumerable:true, get:function() {
  return SubtractiveBlending;
}}, TOUCH:{enumerable:true, get:function() {
  return TOUCH;
}}, TangentSpaceNormalMap:{enumerable:true, get:function() {
  return TangentSpaceNormalMap;
}}, TimestampQuery:{enumerable:true, get:function() {
  return TimestampQuery;
}}, TriangleFanDrawMode:{enumerable:true, get:function() {
  return TriangleFanDrawMode;
}}, TriangleStripDrawMode:{enumerable:true, get:function() {
  return TriangleStripDrawMode;
}}, TrianglesDrawMode:{enumerable:true, get:function() {
  return TrianglesDrawMode;
}}, UVMapping:{enumerable:true, get:function() {
  return UVMapping;
}}, UnsignedByteType:{enumerable:true, get:function() {
  return UnsignedByteType;
}}, UnsignedInt101111Type:{enumerable:true, get:function() {
  return UnsignedInt101111Type;
}}, UnsignedInt248Type:{enumerable:true, get:function() {
  return UnsignedInt248Type;
}}, UnsignedInt5999Type:{enumerable:true, get:function() {
  return UnsignedInt5999Type;
}}, UnsignedIntType:{enumerable:true, get:function() {
  return UnsignedIntType;
}}, UnsignedShort4444Type:{enumerable:true, get:function() {
  return UnsignedShort4444Type;
}}, UnsignedShort5551Type:{enumerable:true, get:function() {
  return UnsignedShort5551Type;
}}, UnsignedShortType:{enumerable:true, get:function() {
  return UnsignedShortType;
}}, VSMShadowMap:{enumerable:true, get:function() {
  return VSMShadowMap;
}}, WebGLCoordinateSystem:{enumerable:true, get:function() {
  return WebGLCoordinateSystem;
}}, WebGPUCoordinateSystem:{enumerable:true, get:function() {
  return WebGPUCoordinateSystem;
}}, WrapAroundEnding:{enumerable:true, get:function() {
  return WrapAroundEnding;
}}, ZeroCurvatureEnding:{enumerable:true, get:function() {
  return ZeroCurvatureEnding;
}}, ZeroFactor:{enumerable:true, get:function() {
  return ZeroFactor;
}}, ZeroSlopeEnding:{enumerable:true, get:function() {
  return ZeroSlopeEnding;
}}, ZeroStencilOp:{enumerable:true, get:function() {
  return ZeroStencilOp;
}}});
const REVISION = "185";
const MOUSE = {LEFT:0, MIDDLE:1, RIGHT:2, ROTATE:0, DOLLY:1, PAN:2};
const TOUCH = {ROTATE:0, PAN:1, DOLLY_PAN:2, DOLLY_ROTATE:3};
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const CullFaceFrontBack = 3;
const BasicShadowMap = 0;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const MaterialBlending = 6;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const ConstantColorFactor = 211;
const OneMinusConstantColorFactor = 212;
const ConstantAlphaFactor = 213;
const OneMinusConstantAlphaFactor = 214;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const AgXToneMapping = 6;
const NeutralToneMapping = 7;
const AttachedBindMode = "attached";
const DetachedBindMode = "detached";
const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const RepeatWrapping = 1000;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipMapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const NearestMipMapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipMapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const LinearMipMapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedInt248Type = 1020;
const UnsignedInt5999Type = 35902;
const UnsignedInt101111Type = 35899;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBIntegerFormat = 1032;
const RGBAIntegerFormat = 1033;
const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const R11_EAC_Format = 37488;
const SIGNED_R11_EAC_Format = 37489;
const RG11_EAC_Format = 37490;
const SIGNED_RG11_EAC_Format = 37491;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const RGB_BPTC_SIGNED_Format = 36494;
const RGB_BPTC_UNSIGNED_Format = 36495;
const RED_RGTC1_Format = 36283;
const SIGNED_RED_RGTC1_Format = 36284;
const RED_GREEN_RGTC2_Format = 36285;
const SIGNED_RED_GREEN_RGTC2_Format = 36286;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const InterpolateBezier = 2303;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const RGBDepthPacking = 3202;
const RGDepthPacking = 3203;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;
const NoColorSpace = "";
const SRGBColorSpace = "srgb";
const LinearSRGBColorSpace = "srgb-linear";
const LinearTransfer = "linear";
const SRGBTransfer = "srgb";
const NoNormalPacking = "";
const NormalRGPacking = "rg";
const NormalGAPacking = "ga";
const ZeroStencilOp = 0;
const KeepStencilOp = 7680;
const ReplaceStencilOp = 7681;
const IncrementStencilOp = 7682;
const DecrementStencilOp = 7683;
const IncrementWrapStencilOp = 34055;
const DecrementWrapStencilOp = 34056;
const InvertStencilOp = 5386;
const NeverStencilFunc = 512;
const LessStencilFunc = 513;
const EqualStencilFunc = 514;
const LessEqualStencilFunc = 515;
const GreaterStencilFunc = 516;
const NotEqualStencilFunc = 517;
const GreaterEqualStencilFunc = 518;
const AlwaysStencilFunc = 519;
const NeverCompare = 512;
const LessCompare = 513;
const EqualCompare = 514;
const LessEqualCompare = 515;
const GreaterCompare = 516;
const NotEqualCompare = 517;
const GreaterEqualCompare = 518;
const AlwaysCompare = 519;
const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const StreamDrawUsage = 35040;
const StaticReadUsage = 35045;
const DynamicReadUsage = 35049;
const StreamReadUsage = 35041;
const StaticCopyUsage = 35046;
const DynamicCopyUsage = 35050;
const StreamCopyUsage = 35042;
const GLSL1 = "100";
const GLSL3 = "300 es";
const WebGLCoordinateSystem = 2000;
const WebGPUCoordinateSystem = 2001;
const TimestampQuery = {COMPUTE:"compute", RENDER:"render"};
const InterpolationSamplingType = {PERSPECTIVE:"perspective", LINEAR:"linear", FLAT:"flat"};
const InterpolationSamplingMode = {NORMAL:"normal", CENTROID:"centroid", SAMPLE:"sample", FIRST:"first", EITHER:"either"};
const Compatibility = {TEXTURE_COMPARE:"depthTextureCompare"};

};